import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { LocationNode } from "../Dto/LocationData";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class LocationSelectorComponentApi {
  private readonly http = inject(HttpClient);

  async loadLocations(): Promise<Record<string, LocationNode>> {
    return await firstValueFrom(this.http.get<Record<string, LocationNode>>("Assets/Libs/Locations.json"));
  }
}
